module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_9016.35a52b01.png";